// extracted by mini-css-extract-plugin
export default {"lessonActions":"SongDetailsLessonActions_lessonActions__0cdtU"};